import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import Button from '../ui/Button'
import { useLocalePath } from '../../hooks/useLocalePath'
import styles from './CTA.module.css'

export default function CTA() {
  const { t } = useTranslation('home')
  const lp = useLocalePath()

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <motion.div
          className={styles.content}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className={styles.title}>{t('cta.title')}</h2>
          <p className={styles.subtitle}>{t('cta.subtitle')}</p>
          <Button variant="secondary" size="lg" href={lp('/contact')}>
            {t('cta.button')} <ArrowRight size={18} />
          </Button>
        </motion.div>
      </div>
    </section>
  )
}
